//import * as React from 'react';
//import {TextInput} from 'react-admin';
//import * as React from "react";

export const SupplierDataTopFilters = (resource, locale) => {
    let dt = [];

    return dt;
}
